import { render, staticRenderFns } from "./AddOrUpdateFreight.vue?vue&type=template&id=c5148f7e&scoped=true"
import script from "./AddOrUpdateFreight.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateFreight.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateFreight.vue?vue&type=style&index=0&id=c5148f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5148f7e",
  null
  
)

export default component.exports